export default class FocusManager {
    constructor(domElement) {
        if(!domElement) {
            throw new Error('element is undefined');
        }

        const isInitialized = (domElement.getAttribute('data-focus-manager-initialized') || 'false') === 'true';

        if(isInitialized === true) {
            throw new Error('Module already initialized');
        }

        domElement.dataset.focusManagerInitialized = 'true';

        this.domElement = domElement;

        this.initEvents();
    }

    initEvents() {
        this.domElement.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
        const targetId = this.domElement.dataset.focusTarget;
        const targetElement = document.querySelector(`[data-focus-id='${targetId}']`);
        targetElement.focus();
    }
}
